<!-- eslint-disable -->
<template lang="html">
  <div class="pms-finder--main">
    <section class="pt-0">
      <div class="container container-2">
        <div class="grid grid--center-y">
            <div class="grid-item is-sm-12 is-md-12 is-10 text-left">
              <!-- <h1>{{ $t('hero.heading') }}</h1>
              <p class="pb-0">{{ $t('hero.subHeading') }}</p>
              <p>{{ $t('hero.subHeadingInfo') }}</p> -->
              <div class="country-filter">
                <div class="h3 filter--title">
                  <div class="countryWrapper">
                    {{ $t('filterSection.selectCountry.label') }}
                    <vue-single-select class="country-select" v-model="pickedCountry" :options="countries" @change="filteredByCountry" :max-results="8" max-height="1000px" option-value="code" option-label="name" :placeholder="$t('filterSection.selectCountry.defaultOption')"></vue-single-select>
                    <div v-if="countryPickerError" class="countryPickerError">
                      {{ $t('filterSection.selectCountry.error') }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="grid-item is-sm-12 nav-form is-hidden is-block-sm">
                <div class="field field--has-addon">
                  <label for="search-form" class="field-label is-assistive">{{ $t('header.searchField.placeholder') }}</label>
                  <div class="field-control">
                    <input v-model="searchText" @keyup.enter="searchResults(1)" type="search" class="field-input" :placeholder="$t('header.searchField.placeholder')" id="search-form-2">
                    <div class="field-addon" style="cursor:pointer;" aria-label="Submit search" @click="searchResults(1)">
                      <i class="fa fa-search fa-lg" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
      </div>
    </section>

    <section class="angled angled--bottom-right " style="margin-top:-1%;" role="region">
      <div class="angled-content" style="padding-top:0;">
        <div class="container">
          <div class="sort-filter-bar is-hidden-sm">
            <div class="sort-alphabetical" @click="sortButtonToggle">
              <figure class="sort-button-img">
                <img v-if="sortOrder === 'asc'" src="//resources.siteminder.com/services/pms-finder/static/Sort-button-asc.svg" width="36px" alt="">
                <img v-if="sortOrder !== 'asc'" src="//resources.siteminder.com/services/pms-finder/static/Sort-button-desc.svg" width="36px" alt="">
              </figure>
              <p v-if="sortOrder === 'asc'" class="sort-button-text lead is-inline-block pb-0">{{ $t('resultsSection.sortOrder.asc') }}</p>
              <p v-if="sortOrder !== 'asc'" class="sort-button-text lead is-inline-block pb-0">{{ $t('resultsSection.sortOrder.desc') }}</p>
            </div>
            <div class="page-count space-lg-left">
              <p class="lead pb-0">{{ filteredPartners.length }} {{ $t('resultsSection.resultsCount') }}</p>
            </div>
            <div class="search-pms-name">
              <div class="text-right">
                <div class="nav-form">
                  <div class="field field--has-addon">
                    <label for="search-form" class="field-label is-assistive">{{ $t('header.searchField.placeholder') }}</label>
                    <div class="field-control">
                      <input v-model="searchText" @keyup.enter="searchResults" type="search" class="field-input" :placeholder="$t('header.searchField.placeholder')" id="search-form">
                      <div class="field-addon" style="cursor:pointer;" aria-label="Submit search" @click="searchResults">
                        <i class="fa fa-search fa-lg" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filter-slide filter-slide-ctr grid-item is-sm-12 nav-form is-hidden is-block-sm">
            <div class="container-2 filter-mobile" :class="{
                'filter-mobile__not-active': (chosenServiceType.length === 0)? true : false,
                'fade-in': (chosenServiceType.length > 0)? true : false,
                'fade-out': (chosenServiceType.length > 0)? false : true,
              }" @click="serviceMobileHidden = !serviceMobileHidden">
              {{ $t('sidebarFilters.serviceType.labelMobile') }}
              <span v-if="(chosenServiceType.length > 0)? true : false" @click.stop="clearFilters(), filteredByCountry()"><em class="fa fa-times"></em> {{ $t('sidebarFilters.serviceType.labelClear') }}</span>
              <i class="fa" :class="{
                'fa-chevron-up': serviceMobileHidden,
                'fa-chevron-down': !serviceMobileHidden
                }">
              </i>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="filter-slide-boxes filter-slide grid-item is-sm-12 nav-form is-hidden is-block-sm" v-if="serviceMobileHidden">
              <div class="container-2 pl-1 pr-1">
                <ul class="sidebar-filters-mobile__list">
                    <li class="sidebar-filters-mobile__list-item" v-for="(serviceType, i) in serviceTypes" :key="i">
                      <button class="button lead text-secondary sidebar-filters-mobile__button" @click="filterServiceType(serviceType), filteredByCountry()">
                        <i v-if="activeFilter(serviceType)" aria-hidden="true" class="fa fa-check-square"></i>
                        <i v-else class="fa fa-square"></i>
                        <span>{{ $t(`sidebarFilters.serviceType.${serviceType}`) }}</span>
                      </button>
                    </li>
                  </ul>
              </div>
            </div>
          </transition>
          <div class="grid space-lg-top">
            <aside class="grid-item is-3 is-sm-12 is-hidden-sm">
              <div class="sidebar-filters">
                <h3 class="sidebar-filters__title text-primary-gradient-dark">{{ $t('sidebarFilters.serviceType.label') }}</h3>
                <ul class="sidebar-filters__list">
                  <li class="sidebar-filters__list-item" v-for="(serviceType, i) in serviceTypes" :key="i">
                    <button class="button lead text-secondary sidebar-filters__button" @click="filterServiceType(serviceType), filteredByCountry()">
                      <i v-if="activeFilter(serviceType)" aria-hidden="true" class="sidebar-filters__active-icon fa fa-check fa-sm"></i>
                      <span>{{ $t(`sidebarFilters.serviceType.${serviceType}`) }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </aside>
            <main class="grid-item is-9 text-center is-sm-12">
              <transition-group name="slide-left" tag="div" class="grid grid--even-height container-2">
                <div v-for="(partner, i) in filteredPartners" :key="partner.name + i" v-if="partner" class="grid-item pms-grid-item is-4 is-lg-4 is-md-6 is-sm-6">
                  <card :title="partner.name" :type="partner" :description="getLangDescription(partner)" :salesEmail="partner.salesEmail" :priority="partner.priority" :logo="partner.logo" :city="partner.city" :badge="partner.badge" :countries="partner.countries" :countryPicked="cardCountry" v-on:noscoll="bodyFix" />
                </div>
              </transition-group>
              <transition name="zoom" v-if="emptySearch" tag="div" class="grid-item is-12">
                <p class="not-found" v-html="nothingFoundText"></p>
              </transition>
            </main>
          </div>
        </div>
      </div>
      <div class="angled-background" aria-hidden="true">
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import VueSingleSelect from "vue-single-select";
import { remove } from 'lodash';
import Card from "@/components/Card.vue";
import Geo from '@siteminder/geo-api';
import { loadedLanguages } from "@/i18n/setup";

export default {
  name: "list",
  props: ["partnerData", "serviceType"],
  components: {
    Card,
    VueSingleSelect
  },

  data() {
    return {
      langs: loadedLanguages,
      countries: this.$t("generic.countries").sort((a, b) => {
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      }),

      searchText: "",
      loading: false,
      showResults: false,
      validation: false,
      emptySearchText: this.$t("resultsSection.validationMessage.emptySearch"),
      nothingFoundText: this.$t(
        "resultsSection.validationMessage.nothingFound"
      ),
      validationText: this.nothingFoundText,
      filteredPartners: this.partnerData,

      loadingTimeout: 500,

      pickedCountry: '',
      countryPickerError: false,
      updatedCountry: "",
      pickedCountryName: "",
      cardCountry: '',
      pickedRoom: null,

      sortOrder: 'asc',
      emptySearch: false,

      serviceTypes: [
        'software',
        'marketing',
        'consulting',
        'revenue',
        'implementation',
      ],
      serviceMobileHidden: false,
      chosenServiceType: this.serviceType,
      noscroll: false,
      scrollY: 0
    };
  },

  watch: {
    pickedCountry: function (val) {
      if (!!val) {
        this.cardCountry = this.getEnglishCountryName(val.code);
        this.countryPickerError = false;
        this.filteredByCountry();
      } else {
        this.emptySearch = true;
        this.countryPickerError = false;
        this.filteredByCountry();
      }
    }
  },

  methods: {
    clearFilters(){
      this.chosenServiceType = []
      this.filteredByCountry()
    },
    bodyFix(e){
      if(e === true){
        this.scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = '100%';
      } else {
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, this.scrollY);
      }
    },
    getEnglishCountryName(code) {
      if (code) {
        let countryList = this.$t('generic.countries', 'en');
        let item = countryList.find(item => code === item["code"]);
        return item.name;
      }
    },

    countryByStart(option) {
      if (option.name && option.code) {
          return (
            option.name
              .toString()
              .toLowerCase()
              .startsWith(this.searchText.toString().toLowerCase()) ||
              option.code
              .toString()
              .toLowerCase()
              .startsWith(this.searchText.toString().toLowerCase())
          )
        }
    },

    getLangDescription(partner) {
      if (this.$i18n.locale !== 'en') {
        const langDesc = partner[this.$i18n.locale];
        if (!!langDesc && !!langDesc.trim()) {
          return partner[this.$i18n.locale];
        } else {
          // disable pms if no language desc found
          remove(this.filteredPartners, {
            name: partner.name
          });
        }
      }
      return partner.enDesc
    },

    sortButtonToggle() {
      if (this.sortOrder === 'asc') {
        this.filteredPartners = this.filterAlphaOnly(this.filteredPartners, 'asc');
        this.sortOrder = 'desc'
      } else {
        this.filteredPartners = this.filterAlphaOnly(this.filteredPartners, 'desc');
        this.sortOrder = 'asc'
      }

    },

    filterAlphaOnly(partners, sortType) {
      if (sortType === "asc") {
        return partners.sort((a, b) => b.name.localeCompare(a.name));
      } else {
        return partners.sort((a, b) => a.name.localeCompare(b.name));
      }
    },

    // sortPartners(partners) {
    //   return partners.sort((a, b) => {
    //     // sort by highest priority first
    //     if (Number(1/a.priority) < Number(1/b.priority)) return 1;
    //     if (Number(1/a.priority) > Number(1/b.priority)) return -1;
    //   });
    // },

    sortCountry(partners, country) {
      return partners.sort((a, b) => {
        // sort by highest priority first
        if(country){
          if(a.countries.includes(country.code)){
            if(b.countries.includes(country.code)){
              // priority search here
              if (Number(1/a.priority) < Number(1/b.priority)) return 1;
              if (Number(1/a.priority) > Number(1/b.priority)) return -1;
            } else {
              return -1;
            }
          }
        } else {
          return (b.name.localeCompare(a.name) > 0)? -1 : 0;
        }
      });
    },

    filterServiceType(type) {
      if (this.chosenServiceType.includes(type)) {
        this.chosenServiceType = this.chosenServiceType.filter(e => e !== type)
      } else {
        this.chosenServiceType.push(type)
      }
    },

    activeFilter(activeValue) {
      if (this.chosenServiceType.includes(activeValue)) {
        return true;
      }
      return false;
    },

    filteredByCountry() {
      this.loading = true;
      this.showResults = false;
      let partners;
      let sortType = this.sortOrder;
      let country = this.pickedCountry;
      this.searchText = '';
      const unFilteredPartners = this.partnerData;

      // if (!!country && country.code) {
      //   partners = unFilteredPartners.filter((partner) => {
      //     if (partner) {
      //       if(typeof partner.countries !== 'undefined'){
      //         if (partner.countries.includes(country.code)) {
      //           return true;
      //         }
      //       }
      //     }
      //   });
      // } else {
      //   partners = unFilteredPartners;
      // }

      if (!!country && country.code) {
        partners = unFilteredPartners.filter((partner) => {
          if (partner) {
            if(typeof partner.countries !== 'undefined'){
              return partner.countries.includes(country.code);
            }
          }
        });
      } else {
        partners = unFilteredPartners;
      }

      if (this.chosenServiceType.length === 1) {
        partners = partners.filter((partner) => {
          if (partner.features) {
            return partner.features.includes(this.chosenServiceType[0]);
          }
        })
      }

      if (this.chosenServiceType.length > 1) {
        partners = partners.filter((partner) => {
          const chosenServiceLength = this.chosenServiceType.length
          let found = 0
          if (partner.features) {
            for (let i = 0; i < chosenServiceLength; i++) {
              if (!!partner.features.includes(this.chosenServiceType[i])) {
                found++;
              }
            }
            if (found === chosenServiceLength) {
              return true
            }
            return false;
          }
        })
      }

      if (partners && partners.length > 0) {
        this.emptySearch = false;
        //this.filteredPartners = this.sortPartners(partners);
        this.filteredPartners = this.sortCountry(partners, country);
      } else {
        this.filteredPartners = partners
        this.emptySearch = true;
      }
    },

    searchResults(e) {
      this.loading = true;
      this.showResults = false;
      let searchedText = this.searchText;
      let country = this.pickedCountry;
      let partners;
      const unFilteredPartners = this.partnerData;

      if (typeof e !== undefined || this.searchText.length) {
        if (this.searchText.trim() !== "") {
          partners = unFilteredPartners.filter(function(partner) {
            if (!!country && country.code) {
              if (partner && partner.name && typeof partner.countries !== 'undefined' && partner.countries.includes(country.code)) {
                return partner.name.toLowerCase().indexOf(searchedText.toLowerCase()) > -1;
              }
            } else {
              if (partner && partner.name) {
                return partner.name.toLowerCase().indexOf(searchedText.toLowerCase()) > -1;
              }
            }
          });

          if (partners && partners.length > 0) {
            this.emptySearch = false;
            this.filteredPartners = partners;
          } else {
            this.emptySearch = true;
            this.filteredPartners = [];
          }
        } else {
            this.filteredByCountry();
            return true;
        }
      } else {
        if (!!country && country.code) {
          partners = unFilteredPartners.filter(function(partner) {
            console.log(partner);
            if(typeof partner.countries !== 'undefined'){
              if (partner && partner.name && partner.countries.includes(country.code)) {
                return true;
              }
            }
          });
        }
      }
      this.chosenServiceType = []
      if (partners && partners.length > 0) {
        this.emptySearch = false;
        this.filteredPartners = partners;
      } else {
        this.emptySearch = true;
        this.filteredPartners = [];
      }
    },
    geoLocation () {
      const $geo = new Geo();
      let countryList = this.countries;
      // eslint-disable-next-line
      $geo.ready((location) => {
        let geoCode = location.country.code
        let item = countryList.find(item => geoCode === item["code"]);
        this.pickedCountry = item;
      })
    },
  },

  mounted() {
    this.geoLocation();
  }
};
</script>

<style lang="scss" >
@import "~@siteminder/chameleon-variables";
$input-background: #eee;

.fade-in {
	animation: fade-in 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

@keyframes fade-in {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

.fade-out {
	animation: fade-out 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: .6;
  }
}

.slide-fade-enter-active {
  animation: scale-in-ver-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940);
}

.slide-fade-leave-active {
  animation: scale-in-ver-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) reverse;
}

@keyframes scale-in-ver-top {
  0% {
    transform: translateY(-400px);
    //transform: scaleY(0);
    transform-origin: 100% 0%;
     opacity: 1;
  }
  80% {
    //transform: scaleY(1);
    transform: translateY(0);
    transform-origin: 100% 0%;
    opacity: .94;
  }
  100% {
    //transform: scaleY(1);
    transform: translateY(-4px);
    transform-origin: 100% 0%;
    opacity: .94;
  }
}

#search-form, #search-form-2 {
  font-size: 15px;
}

input#search-form,
input#search-form-2 {
  font-size: 100%;
}

@media #{$tablet} {
  .section.nav-space.section--sm {
    padding-top: 3em;
  }

  .section.section--sm {
    padding-bottom: 0;
  }

  .filter-slide {
    background-color: $primary;
    color: #fff;
    left: 0;

    &.filter-slide-boxes {
      position: absolute;
      top: 10px;
      z-index: 1;
      opacity: .94;
    }

    &.filter-slide-ctr {
      z-index: 2;
      position: absolute;
      top: -31px;
      border-top: 1px solid rgba(255, 255, 255, 0.3);
      border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    }
  }

  .angled.angled--bottom-right {
    padding: 0;
  }

  .not-found {
    padding: 40px 50px;
  }

  .container-2 {
    &.filter-mobile {
      padding: 10px 0 12px 1.3rem;
      &__not-active{
        opacity: 0.6;
      }
      i {
        position: absolute;
        right: 15px;
        top: 13px;
      }
      em {
      position: relative;
      top: -1px;
      right: 2px;
      font-size: 13px;
      }
      span {
        position: absolute;
        right: 40px;
        top: 7px;
        background-color: #fff;
        color: $primary;
        padding: 4px 10px;
        border-radius: 3px;
      }
    }
  }

  .grid-item {
    padding: 0.65rem 1.3rem 1.3rem;
  }
}

/* Reset default browser styles */
ul {
  padding-left: 0;
}

ul li {
  list-style: none;
}

/* Search form */
.nav-form {
  padding: 0 !important;
  float: left;
}

/* Header */
.header-logo {
  max-height: 60px;
  margin: auto !important;
  margin-left: 0 !important;
}

/* Filter section */
.filter--title {
  padding-bottom: 1rem;
  position: relative;
}

/* Sidebar filters */
.sidebar-filters {
  &__list {
    padding-bottom: 10px;
  }
  &__list-item {
    margin: 0;
  }

  &__title {
    padding-bottom: 10px;
  }

  &__button {
    width: 100%;
    text-align: left;
    background: transparent;
    padding: 4px;
    margin: 0;
    position: relative;
    outline: transparent;
    i {
      outline: transparent;
      box-shadow: none!important;
    }
  }

  &__active-icon {
    position: absolute;
    padding-right: 5px;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
}

/* Sidebar filters */
.sidebar-filters-mobile__list-item {
  .sidebar-filters-mobile__button {
    font-size: 15px;
    line-height: 24px;
  }
}

.sidebar-filters-mobile {
  color: white;

  &__list {
    padding-top: 30px;
    padding-bottom: 10px;
  }
  &__list-item {
    margin: 0;
  }

  &__title {
    padding-bottom: 10px;
  }

  &__button {
    color: white;
    width: 100%;
    text-align: left;
    background: transparent;
    padding: 4px;
    margin: 0;
    position: relative;
    outline: transparent;

    i {
      margin-right: 6px;
      outline: transparent;
      box-shadow: none!important;
    }

    &:hover {
      background: none !important;
    }
  }
}

.country-filter {
  .countryWrapper {
    display: inline-block;
    position: relative;
  }
  .countryPickerError {
    display: block;
    position: absolute;
    top: -35px;
    right: 20px;
    background-color: #e51b00;
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(43%, #e51b00), to(#ba1600));
    background-image: linear-gradient(#e51b00 43%, #ba1600 100%);
    background-image: -ms-linear-gradient(#e51b00 43%, #ba1600 100%);
    border: 1px solid #9f1300;
    border-radius: 6px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.65) 0 2px 7px, inset #ff3c3c 0 1px 0px;
    box-shadow: rgba(0, 0, 0, 0.65) 0 2px 7px, inset #ff3c3c 0 1px 0px;
    color: #f3f3f3;
    font-size: 13px;
    line-height: 1.2em;
    padding: 0.4em 0.6em;
    text-shadow: #901100 0 -1px 0;

    &:after {
    height: 8px;
    position: absolute;
    top: 25px;
    left: 5px;
    z-index: 1;
    content: '';
    display: inline-block;
    -ms-transform: rotate(45deg);
    border-top: 8px solid #9f1300;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    border-bottom: none;
    }
  }
}

.sort-filter-bar {
  display: inline-block;
  width: 100%;

  > * {
    display: inline-block;
  }

  .search-pms-name {
    float: right;
  }

  .sort-alphabetical, .page-count {
    line-height: 50px;
  }

  .sort-alphabetical {
    cursor: pointer;
  }

  .sort-button-img {
    display: inline-block;
  }

  .sort-button-text {
    line-height: 50px;
    padding-left: 5px;
  }
}

.country-select {
  display: inline-block;
  padding-right: 1em;
  .search-input {
    color: $secondary;
    padding: 5px 30px 5px 10px;
    border-radius: $radius;
    line-height: 1em;
  }
  .search-input::placeholder {

  }
  .icons {
    // display: none!important;
    fill: #005780;
  }

  ul.dropdown {
    color: $secondary;
    li {
      margin-bottom: 0;
    }
  }
}

.room-select-wrapper {
  display: inline-block;
  // padding-left: 1em;
  .search-input {
    // display: block;
    // width: 100%;
    max-width: 90px;
    color: $secondary;
    padding: 5px 10px;
    border-radius: $radius;
    font-size: 1em;
    line-height: 1em;
    background-color: #fff;
    border: 1px solid #ced4da;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    box-sizing: border-box;
  }
}
/* Custom select fields */
.select-link {
  display: inline-block;
  position: relative;

  .select {
    color: transparent;
    border: none;
    left: 0;
    top: 0;
    width: 100%;
    position: absolute;
    background: transparent;
    appearance: button;
    cursor: pointer;
  }
}
.select-box {
  display: inline-block;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
}
.select-box select {
  background-color: white;
  color: inherit;
  padding: 8px;
  width: 300px;
  border: 1px solid #f2f2f2;
  font-size: 1em;
  appearance: button;
  outline: none;
  cursor: pointer;
}

.select-box::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 20%;
  height: 100%;
  text-align: right;
  margin-right: 13px;
  font-size: 1em;
  line-height: 37px;
  // color: rgba(255, 255, 255, 0.5);
  background-color: rgba(255, 255, 255, 0.1);
  pointer-events: none;
}

.select-box select option {
  padding: 30px;
}

.pms-grid-item {

  @media #{$mobile} {
    width: 100%!important;
  }
}

.zoom-enter-active,
.zoom-leave-active {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-name: zoom;
}

.zoom-leave-active {
  animation-direction: reverse;
}

@keyframes zoom {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  100% {
    opacity: 1;
  }
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.3, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
<style lang="scss">
$input-background: #eee;
/** GLOBAL CSS
*
*
**/

/* Tooltips */
.tooltip {
  background: #f2f2f2;
  padding: 0;
  height: 15px;
  font-weight: bold;
  font-size: 10px;
  top: -10px;
  margin-left: 10px;
  width: 15px;
  border-radius: 50%;
  &.text-success {
    background: #509e2f;
    color: white;
  }
}

.tooltip .tooltiptext {
  min-width: 200px;
  max-width: 400px;
  top: 50%;
  left: 100%;
  margin-left: 10px;
  min-height: 30px;
  transform: translate(0, -50%);
  padding: 0;
  color: #eee;
  background-color: #444444;
  font-weight: normal;
  font-size: 13px;
  border-radius: 8px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  visibility: hidden;
  transition: opacity 0.8s;
}
.tooltip .tooltiptext i {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -12px;
  margin-right: -3px;
  width: 12px;
  height: 24px;
  overflow: hidden;
  &:after {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    left: 0;
    top: 50%;
    transform: translate(50%, -50%) rotate(-45deg);
    background-color: #444444;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  }
}

.tooltip:hover {
  cursor: pointer;
  .tooltiptext {
    visibility: visible;
  }
}

.guest-type--options {
  .grid {
    .grid-item {
      .card {
        cursor: pointer;
        min-height: 250px;
        /* Checkbox */
        label {
          display: block;
          position: relative;
          padding-left: 35px;
          margin-bottom: 12px;
          cursor: pointer;
          // font-size: 22px;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }

        /* Hide the browser's default checkbox */
        label input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;
        }

        /* Create a custom checkbox */
        .checkmark {
          position: absolute;
          top: 0;
          left: 0;
          height: 21px;
          width: 21px;
          background-color: $input-background;
          border-radius: 50%;
        }

        /* When the checkbox is checked, add a blue background */
        label input:checked ~ .checkmark {
          background-color: #008bce;
        }

        /* Create the checkmark/indicator (hidden when not checked) */
        .checkmark:after {
          content: "";
          position: absolute;
          display: none;
        }

        /* Show the checkmark when checked */
        label input:checked ~ .checkmark:after {
          display: block;
        }

        /* Style the checkmark/indicator */
        label .checkmark:after {
          left: 6px;
          top: 2px;
          width: 5px;
          height: 10px;
          border: solid white;
          border-width: 0 3px 3px 0;
          -webkit-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          transform: rotate(45deg);
        }

        &:hover {
          /* On mouse-over, add background color */
          label input ~ .checkmark {
            background-color: #008bce;
          }
        }
        &.isActive {
          border-color: #008bce;
        }
      }
    }
  }
}
.select-box {
  width: 100%;
  cursor: pointer;
  label {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 13px;
    cursor: pointer;
  }
  select.select {
    padding-left: 35px;
    width: 100%;
  }
  &:hover {
    &:before {
      color: #005780;
    }
    label {
      color: #005780;
    }
    select.select {
      color: #005780;
    }
  }
}

.button {
  &.button--og-secondary {
    background: #00344d;
    &:hover {
      background: darken(#00344d, 5%);
    }
  }
}

.results--section--top-image {
  img {
    width: 3000px;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
</style>
